// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.v-toolbar__content[data-v-16293040] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
